import Lightbox from "stimulus-lightbox"

export default class extends Lightbox {
  get defaultOptions () {
    return {
      download: false,
    }
  }
}
